module.exports = __webpack_public_path__ + "img/c90920c6ee03c70231e1b1575e1824ab.bb852e7e.png";